var moment = module.exports = require("./moment-timezone");
moment.tz.load(require('./data/packed/latest.json'));



//////////////////
// WEBPACK FOOTER
// /~/moment-timezone/index.js
// module id = 2177
// module chunks = 0